import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import ENV from "app/utils/ENV";
import {
  StyleSheet,
  View,
  ScrollView,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  Dimensions,
  Alert,
} from "react-native";
import TouchableOpacity from "app/components/TouchableOpacity";
import Text from "app/components/Text";
import TextInput from "app/components/TextInput";
import authActions from "app/utils/authActions";
import storageActions from "app/utils/storageActions";
// import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import { styleSheet, colors, sizes, WIDTH } from "app/utils/styleSheet";

import { StyleContext } from "app/contexts/Style";

export default class AuthScreen extends React.Component {
  static contextType = StyleContext;
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      verificationCode: "",
      loading: false,
      acceptCode: false,
      error: "",
    };
  }

  async componentDidMount() {}

  render() {
    let { email, verificationCode, loading, acceptCode, error } = this.state;
    let invalid =
      loading || !email?.length || (acceptCode && !verificationCode?.length);

    return (
      <View style={[this.styles().container]}>
        {acceptCode && (
          <Text trim style={this.styles().item}>
            Code has been emailed. Check spam.
          </Text>
        )}

        {acceptCode ? (
          <TextInput
            autoFocus
            value={verificationCode}
            placeholder={"Code"}
            style={this.styles().item}
            onEnter={this.handleContinue}
            onChangeText={(val) => this.setState({ verificationCode: val })}
            wrapperStyle={{ flex: -1 }}
          />
        ) : (
          <TextInput
            autoFocus
            value={email}
            placeholder={"Email"}
            style={this.styles().item}
            onEnter={this.handleContinue}
            onChangeText={(val) => this.setState({ email: val })}
            wrapperStyle={{ flex: -1 }}
          />
        )}

        <TouchableOpacity
          onPress={() => this.handleContinue()}
          disabled={loading || invalid}
        >
          <Text
            selectedButton
            style={[
              this.styles().item,
              invalid && { color: this.context.colors.fill },
            ]}
          >
            Continue{" "}
            {loading && (
              <ActivityIndicator
                color={this.context.colors.fill}
                style={{
                  position: "absolute",
                  right: this.context.sizes.large,
                }}
              />
            )}
          </Text>
        </TouchableOpacity>

        {!!error?.length && (
          <Text red style={this.styles().item}>
            {error}
          </Text>
        )}
      </View>
    );
  }

  handleContinue = async () => {
    let { loading, email, verificationCode, acceptCode } = this.state;
    if (loading || !email?.length || (acceptCode && !verificationCode?.length))
      return;
    this.setState({ loading: true });
    if (acceptCode) {
      let res = await authActions.submitVerificationCode(
        textHelpers.trimWhiteSpace(email),
        textHelpers.trimWhiteSpace(verificationCode),
      );
      if (res?.success) {
        let token = res.token;
        await storageActions.saveItem("token", token);
        // this.props.onSetToken(token, res.value_id);
        this.props.onSetToken(token, res.intro);
      } else {
        this.setState({
          loading: false,
          email: "",
          verificationCode: "",
          acceptCode: false,
          error: "Incorrect. Please try again.",
        });
      }
    } else {
      let res = await authActions.submitEmail(
        textHelpers.trimWhiteSpace(email),
      );
      if (res?.success) {
        this.setState({ loading: false, acceptCode: true, error: "" });
      } else {
        this.setState({
          loading: false,
          acceptCode: false,
          error: "Something went wrong. Please try again.",
        });
      }
    }
  };

  styles = () => ({
    container: {
      flex: 1,
      backgroundColor: this.context.colors.empty,
      justifyContent: "center",
      alignItems: "center",
    },
    item: {
      width: Math.min(WIDTH, 400),
      marginBottom: this.context.sizes.large,
      textAlign: "center",
    },
  });
}
